import React, { useState, useContext } from 'react';
import DocumentContext from '../context/DocumentContext';

export default function AddDocumentDialog({ onClose, archiveItemId }) {
    const [formData, setFormData] = useState({
        document_name: '',
        persian_name: '',
        description: '',
        persian_description: '',
        author: '',
        persian_author: '',
        year: '',
        image: null
    });
    const { addDocument } = useContext(DocumentContext);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFormData(prev => ({
                ...prev,
                image: file
            }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        // Format the data to match what addDocument expects
        const newDocument = {
            name: formData.document_name,
            persian_name: formData.persian_name,
            description: formData.description,
            persian_description: formData.persian_description,
            author: formData.author,
            persian_author: formData.persian_author,
            year: formData.year,
            image: formData.image
        };
        
        // Log the payload before sending to backend
        console.log('Document payload:', newDocument);
        
        const response = await addDocument(archiveItemId, newDocument);
        console.log('Backend response:', response);
        onClose();
    };

    return (
        <>
            <div className="dialog-overlay" onClick={onClose} />
            <div className="dialog">
                <h2 className="dialog__title">Add New Document</h2>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="document_name">Document Name (English):</label>
                        <input
                            type="text"
                            id="document_name"
                            name="document_name"
                            value={formData.document_name}
                            onChange={handleInputChange}
                            required
                            placeholder="Enter document name in English"
                        />
                    </div>
                    
                    <div className="form-group">
                        <label htmlFor="persian_name">Document Name (Persian):</label>
                        <input
                            type="text"
                            id="persian_name"
                            name="persian_name"
                            value={formData.persian_name}
                            onChange={handleInputChange}
                            required
                            placeholder="نام سند را به فارسی وارد کنید"
                            dir="rtl"
                        />
                    </div>
                    
                    <div className="form-group">
                        <label htmlFor="description">Description (English):</label>
                        <textarea
                            id="description"
                            name="description"
                            value={formData.description}
                            onChange={handleInputChange}
                            required
                            rows="4"
                            placeholder="Enter document description in English"
                        />
                    </div>
                    
                    <div className="form-group">
                        <label htmlFor="persian_description">Description (Persian):</label>
                        <textarea
                            id="persian_description"
                            name="persian_description"
                            value={formData.persian_description}
                            onChange={handleInputChange}
                            required
                            rows="4"
                            placeholder="توضیحات سند را به فارسی وارد کنید"
                            dir="rtl"
                        />
                    </div>
                    
                    <div className="form-group">
                        <label htmlFor="author">Author (English):</label>
                        <input
                            type="text"
                            id="author"
                            name="author"
                            value={formData.author}
                            onChange={handleInputChange}
                            required
                            placeholder="Enter author name in English"
                        />
                    </div>
                    
                    <div className="form-group">
                        <label htmlFor="persian_author">Author (Persian):</label>
                        <input
                            type="text"
                            id="persian_author"
                            name="persian_author"
                            value={formData.persian_author}
                            onChange={handleInputChange}
                            required
                            placeholder="نام نویسنده را به فارسی وارد کنید"
                            dir="rtl"
                        />
                    </div>
                    
                    <div className="form-group">
                        <label htmlFor="year">Year/Period:</label>
                        <input
                            type="text"
                            id="year"
                            name="year"
                            value={formData.year}
                            onChange={handleInputChange}
                            required
                            placeholder="e.g., 1853, 1850s, circa 1886, 1850 to 1860"
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="image">Document Image:</label>
                        <input
                            type="file"
                            id="image"
                            name="image"
                            onChange={handleImageChange}
                            accept="image/*"
                        />
                    </div>
                    
                    <div className="dialog__buttons">
                        <button 
                            type="button" 
                            className="dialog__button dialog__button--cancel"
                            onClick={onClose}
                        >
                            Cancel
                        </button>
                        <button 
                            type="submit" 
                            className="dialog__button dialog__button--submit"
                        >
                            Add Document
                        </button>
                    </div>
                </form>
            </div>
        </>
    );
} 